import Plugin from 'lib/modulor/plugin'

export default class Loader extends Plugin
  @defaults =
    debug: false
    name: 'AttachmentListModule__Loader'

  @selector: ".attachment_list_module"

  on_init: ->
    `import('./attachment_list_module' /* webpackChunkName: "attachment_list_module" */)`

Loader.register()
